import React, { useEffect, useState } from "react";
import { keyEntry } from "../../../system/types/project/project";
import { initialKeyEntry } from "../../../system/initial/project";
import { mdiContentCopy, mdiCodeBraces, mdiNoteEditOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { dispatch } from "../../../App";
import { actions } from "../../../redux";

interface props {
    groupId: string;
    groupKey: string;
    keyEntry: keyEntry;
}

const EntryTranslation = (props: props) => {

    const [entry, setEntry] = useState<keyEntry>(initialKeyEntry);


    const copyIdToClipboard = () => {
        const text = props.groupKey + '.' + entry.key;
        navigator.clipboard.writeText(text);
    }

    const copyCodeToClipboar = () => {
        const text = '{t(\'' + props.groupKey + '.' + entry.key + '\', \'' + entry.name + '\')}';
        navigator.clipboard.writeText(text);
    }


    const editTranslation = (translationId: string) => {
        dispatch(actions.project.setPageCommand('editTranslation'));
        dispatch(actions.project.setPageCommandId(translationId));
        dispatch(actions.project.setPageCommandSubSelect(props.groupId));
    };


    useEffect(() => {
        setEntry(props.keyEntry);
    }, [props.keyEntry])

    return (<>
        <div className="row mb-3">
            <div className="col-1"></div>
            <div className="col-6">
                <div className="row">
                    <div className="col-auto"><strong>{entry.name}</strong> ({props.groupKey}.{entry.key})</div>
                    <div className="col-auto">
                        <span className="link" onClick={copyIdToClipboard}><Icon path={mdiContentCopy} size={1} /></span>
                        <span className="link" onClick={copyCodeToClipboar}><Icon path={mdiCodeBraces} size={1} /></span>
                    </div>
                </div>
            </div>
            <div className="col-auto"><button onClick={() => {
                editTranslation(entry.uniqueId);
            }} className="btn btn-outline-primary">
                <Icon path={mdiNoteEditOutline} size={1} />
            </button></div>
        </div>
    </>);
}

export { EntryTranslation };
